import React from 'react';
import * as ui from './Unauthorized.styled';
import { TEXT } from '../constants';

export type UnauthorizedProps = {
    message?: string;
}

export const Unauthorized: React.FC<UnauthorizedProps> = ({ message }) => {
    return (
        <ui.PageContainer>
            <ui.PageTitle>Unauthorized</ui.PageTitle>
            <ui.UnauthorizedText>
                {message ?? TEXT.Unauthorized.DefaultMessage}
            </ui.UnauthorizedText>
        </ui.PageContainer>
    );
}